import {Component, Injector, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { GLMLanguageService } from 'src/app/_services/glm-language.service';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { AccountService } from 'src/app/_services/account.service';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { UnidadEtapasService } from '../../unidad-etapas/_services/unidad-etapas.service';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { Unidad } from 'src/app/_models/unidad';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-retroalimentacion-barra',
  standalone: false,
  templateUrl: './retroalimentacion-barra.component.html',
  styleUrls: ['./retroalimentacion-barra.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionBarraComponent implements OnInit, OnDestroy {

  unidad: Unidad;

  materias: any = [];

  comentariosObservable;
  idiomaDisplay$;

  languageSubscription: Subscription;

  idiomas$;

  constructor(private injector: Injector,
              private langService: GLMLanguageService,
              private unidadEtapasService: UnidadEtapasService,
              private globalService: GlobalService,
              private userService: AccountService,
              private throbberService: ThrobberService,
              private customAlertService: CustomAlertService) {
  }


  ngOnInit() {
    this.idiomas$ = this.globalService.idiomas$;
    this.idiomaDisplay$ = this.langService.getLanguageObservable().pipe(
      map(data => {
        return data.activeLang.nickName.toUpperCase();
      })
    );
    this.unidad = this.injector.get('unidad');
  }

  cambiarIdioma(idioma: string) {
    this.throbberService.setThrobberState(true);
    this.unidadEtapasService.setLanguage(idioma, this.unidad, this.userService.getUser().id).subscribe(
      res => {
        this.throbberService.setThrobberState(false);
        this.langService.setLanguage({nickName: idioma});
      },
      err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible cambiar el idioma de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
        });
      }
    );
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
